import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';

import { selectUser } from '../../../store/app.selectors';

import { IUserProfile } from '../../user/interfaces/IUserProfile';
import { DealerSettingName } from '../interfaces/IDealerSettings';
import { AppStateWithChat } from '../store/chat.reducer';

@Injectable()
export class AlternateTranslationService {
  currentUserSesion: IUserProfile | null = null;
  constructor(private store: Store<AppStateWithChat>) {
    this.store.select(selectUser).subscribe((user) => {
      this.currentUserSesion = user;
    });
  }

  alternate(text: string): string {
    if (!this.currentUserSesion?.dealerSettings?.length) {
      return text;
    }
    const setting = this.currentUserSesion?.dealerSettings.find(
      (element) => element.key === DealerSettingName.messagingI18N
    );
    if (setting && setting.value !== 'DEFAULT')
      if (setting) {
        text = `NGX-MESSAGING.${setting.value}.${text}`;
        return text;
      }
    return 'NGX-MESSAGING.' + text;
  }
}
